export default __webpack_public_path__ + "static/popup-image-b8b48ffe344c048d211be4239143af19.jpg";